import { app } from "@/main.js"

/*
import axios from 'axios';
import jwt_decode from 'jwt-decode';

let inactivityTimer = null;
let absoluteTimer = null;
let tokenRefreshTimer = null;

const TWO_HOURS = 2 * 60 * 60 * 1000;
const FIVE_MINUTES = 5 * 60 * 1000;
*/

const defaultState = () => {
	return {
		accessType: null,
		accessToken: null,
		isAuthenticated: false,
		tokenExpiry: null,
		jwtPayload: null,
		isSuperAdmin: false,
		isOrganisationAdmin: false,
		isAuditAdmin: false,
		isGeneralUser: false,
		hasOrg: false,
		token: null,
		isTokenExpired: false,
		organisationsList: null,
		currentOrganisation: {},
		currentUser: null,
		usersWithVertexRoles : null,
		usersWithAuditAdminRole: null,
		userRole: '',
	}
}

const state = () => ({
	accessType: null,
	accessToken: null,
	isAuthenticated: false,
	tokenExpiry: null,
	jwtPayload: null,
	isSuperAdmin: false,
	isOrganisationAdmin: false,
	isAuditAdmin: false,
	isGeneralUser: false,
	hasOrg: false,
	token: null,
	isTokenExpired: false,
	redirectLink: null,
	organisationsList: null,
	currentOrganisation: {},
	currentUser: null,
	usersWithVertexRoles : null,
	usersWithAuditAdminRole: null,
});

const getters = {}

const actions = {
	resetState({ commit }) {
		commit("resetState")
	},

	logout({ commit, state }) {
		/*
		clearTimeout(inactivityTimer);
		clearTimeout(absoluteTimer);
		clearTimeout(tokenRefreshTimer);
		*/
		
		let logoutUrl = `${app.config.globalProperties.$config.getLoginLink()}&logout=true`

		if (!state.isSuperAdmin && (state.accessType == null && (!state.isOrganisationAdmin && !state.isAuditAdmin && !state.isGeneralUser))) {
			logoutUrl = `${logoutUrl}&message=Unauthorized access. Please contact administrator.`;
		}

		if (state.isTokenExpired) {
			logoutUrl = `${logoutUrl}&error=TOKEN_EXPIRE`
		}

		if (!state.isAuthenticated) {
			logoutUrl = `${app.config.globalProperties.$config.getLoginLink()}&logout=true`;
		}

		if (state.redirectLink != null) {
			logoutUrl = `${logoutUrl}&redirectTo=${app.config.globalProperties.$config.getServerHost()}${state.redirectLink}`;
		}
		
		commit("resetState");

		window.location.href = logoutUrl
	},

	/*
	initializeSessionTrackers({ dispatch }, payload) {
		clearTimeout(absoluteTimer);
		clearTimeout(tokenRefreshTimer);

		if (payload) {
			if (payload.iat) {
				dispatch("startAbsoluteSessionTracker", payload);
			}
			if (payload.exp) {
				dispatch("scheduleProactiveTokenRefresh", payload);
			}
		}
	},

	handleUserActivity({ state, dispatch }) {
		const jwtPayload = state.jwtPayload;
		if (jwtPayload && jwtPayload.exp) {
			const tokenTimeLeft = (jwtPayload.exp * 1000) - Date.now();

			// Fail-safe refresh if token is within 5 minutes of expiring (e.g. browser throttled tabs)
			if (tokenTimeLeft > 0 && tokenTimeLeft <= FIVE_MINUTES) {
				dispatch("triggerTokenRefresh");
			}
		}

		// Reset inactivity countdown
		clearTimeout(inactivityTimer);
		inactivityTimer = setTimeout(() => {
			dispatch("logout");
		}, TWO_HOURS);
	},

	scheduleProactiveTokenRefresh({ dispatch }, jwtPayload) {
		if (!jwtPayload || !jwtPayload.exp) return;

		const expiryTimeMs = jwtPayload.exp * 1000;
		const timeUntilRefreshMs = (expiryTimeMs - Date.now()) - FIVE_MINUTES;

		if (timeUntilRefreshMs > 0) {
			tokenRefreshTimer = setTimeout(() => {
				dispatch("triggerTokenRefresh");
			}, timeUntilRefreshMs);
		}
	},

	startAbsoluteSessionTracker({ dispatch }, jwtPayload) {
		if (!jwtPayload || !jwtPayload.iat) return;

		const originalLoginMs = jwtPayload.iat * 1000;
		const twelveHoursMs = 12 * 60 * 60 * 1000;
		const absoluteExpiryTime = originalLoginMs + twelveHoursMs;
		const msUntilAbsoluteExpiry = absoluteExpiryTime - Date.now();

		if (msUntilAbsoluteExpiry > 0) {
			absoluteTimer = setTimeout(() => {
				alert("Your maximum session duration of 12 hours has been reached. For security, you are being logged out.");
				dispatch("logout");
			}, msUntilAbsoluteExpiry);
		} else {
			dispatch("logout");
		}
	},

	async triggerTokenRefresh({ state, commit, dispatch }) {
		try {
			if (!state.accessToken || !state.jwtPayload) return;

			const data = {
				id: state.jwtPayload.user_id,
				access_token: state.accessToken,
				refresh_token: state.jwtPayload.jwt_refresh_token
			};

			const response = await axios.post('/auth/token/refresh', data);
			const newAccessToken = response.data.user.access_token;

			// Commit updates which will automatically reschedule new timers
			commit("setAccessToken", newAccessToken);
			commit("setJwtPayload", jwt_decode(newAccessToken));
			axios.defaults.headers.common['Authorization'] = 'Bearer ' + newAccessToken;
		} catch (error) {
			console.error("Failed to automatically refresh token:", error);
			commit("setIsTokenExpired");
			dispatch("logout");
		}
	},
	*/
};

const mutations = {
	resetState(state) {
		Object.assign(state, defaultState());
	},

	setAccessToken(state, accessToken) {
		state.accessToken = accessToken;
	},

	setJwtPayload(state, payload) {
		state.jwtPayload = payload;
		state.tokenExpiry = payload.expires_at;

		if (payload && payload.roles) {
			
			state.isSuperAdmin = payload.roles.includes("super_admin");
			state.userRole = "Super Admin"
			// for vertex roles
			if (!state.isSuperAdmin) {
				if (payload.roles.includes("consultant_admin")) {
					state.accessType = 'consultant_admin'
					state.userRole = "Consultant Admin"
				// } else if (payload.roles.includes("consultant")) {
				// 	state.accessType = 'consultant'
				} else {
					state.accessType = null
					state.userRole = ""
				}
			}
		}

		if (payload.organisation_role != null) {
			state.hasOrg = true

			if (payload.organisation_role[0].products != null) {
				payload.organisation_role[0].products.forEach((p) => {
					
					if (p.product == "audit" || p.product.includes("alke") || p.product == ("alke_platform")) {

						state.isOrganisationAdmin = payload.organisation_role[0].is_organisation_admin
						state.userRole = state.accessType == null ? "Organisation Admin" : state.userRole
						if (state.accessType == null && !state.isOrganisationAdmin) {
							if (p.roles.includes("audit_admin") || p.roles.includes("admin")) {
								state.isAuditAdmin = p.roles.includes("audit_admin") || p.roles.includes("admin")
								state.userRole = state.accessType == null ? "Audit Admin"  : state.userRole
							} else if (p.roles.includes("general_user")) {
								state.isGeneralUser = p.roles.includes("general_user")
								state.userRole = state.accessType == null ? '' : state.userRole
							}
						} 
					}
						
				})
			}

		}

		state.currentUser = {
			id: payload.user_id,
			uuid: payload.user_uuid,
			first_name: payload.first_name,
			last_name: payload.last_name,
			organisation: {
				id: payload.organisation_role != null ? payload.organisation_role[0].organisation_id : 0,
				orguuid: payload.organisation_uuid,
				name: payload.organisation_role != null ? payload.organisation_role[0].organisation : "",
			}
		}

		// this.dispatch("auth/initializeSessionTrackers", payload);
	},

	authenticated(state, authenticated) {
		state.isAuthenticated = authenticated;
	},

	setIsTokenExpired(state) {
		state.isTokenExpired = true;
	},

	setRedirectLink(state, link) {
		state.redirectLink = link
	},

	setOrganisationsList(state, orgs) {
		state.organisationsList = orgs
	},

	setCurrentOrganisation(state, org) {
		state.currentOrganisation = org
	},

	setCurrentUser(state, user) {
		state.currentUser = user
	},

	setUsersWithVertexRoles(state, users) {
		state.usersWithVertexRoles = users
	},

	setUsersWithAuditAdminRole(state, users) {
		state.usersWithAuditAdminRole = users
	},
};

export default {
	name: "auth",
	namespaced: true,
	state,
	getters,
	actions,
	mutations,
};
